import styles from './LeaderboardHeader.module.css'

const LeaderboardHeader = () => {
    return (
        <div className={styles.leaderboardHeader}>
            <div className={styles.leaderboardHeader__content}>
                <div className={styles.leaderboardHeader__title}>
                    Турнирная таблица
                </div>
                <div className={styles.subtitle}>
                    Зарабатывай бисткоины и вырывайся в лидеры
                </div>
            </div>
        </div>
    )
}

export default LeaderboardHeader